const styles = theme => ({
  textColor: {
    color: 'rgba(52, 118, 203, 1.0)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/City/styles.js